<template>
  <section class="wrapper">
    <div class="header">
      <p class="text">选择公司</p>
      <img src="../../assets/img/company.png" alt="">
    </div>
    <van-row class="search-panel">
      <van-col span="18">
        <van-search shape="round" placeholder="请输入您要查询的公司名称" @click="toSearch"/>
      </van-col>
      <van-col span="6" class="add-company">
        <i class="iconfont iconfont-jiaqian"></i><i class="ml5">添加公司</i>
      </van-col>
    </van-row>
    <aside class="company-list">
      <van-row align="center" justify="center" class="company-item" v-for="(item,index) in companyList" :key="index" @click="selectCompany(item.C_GUID)">
        <van-col span="20">
          <span class="full-name">{{item.ChineseFullName}}</span>
          <span class="about-info">
          <i>公司简称：{{item.Name}} </i>
          <i>上次进入：{{item.EnterDate.slice(0,11).replace(/-/g, "/").replace(/-/g, "/").replace(/-/g, "")}}</i>
        </span>
        </van-col>
        <van-col span="4" class="role-name">{{item.UserGroup}}</van-col>
      </van-row>
    </aside>
  </section>
</template>

<script>
  import {getCompanyListApi} from '@/api/company'
  import {initUserCompanyApi} from '@/api/common'
  export default {
    name: "company",
    data() {
      return {
        from: {
          CompanyName: '',
          loginName: '',
        },
        CompanyId: '',
        companyList: []
      }
    },
    mounted: function () {
      this.getCompanyList();
    },
    methods: {
      addCom() {
        this.$router.push({path: '/addcom'})
      },
      a() {
        let getdate = new Date().getTime()
        let b = sessionStorage.getItem('datacon')
        let c = 3600 * 1000 * 24
        if (getdate - b > c) {
          this.$router.push({path: '/bindingcon'})
        }
      },
      async getCompanyList() {
        let userInfo = this.getCookie("UserInfo");
        let params = {
          companyName: '',
          uGuid: userInfo.U_GUID
        };
        let response = await getCompanyListApi(params);
        if (response.success) {
          this.companyList = response.result
        }
      },
      //选择公司
      async selectCompany(cGuid) {
        let userInfo = this.getCookie("UserInfo");
        let params = {
          cGuid: cGuid,
          uGuid: userInfo.U_GUID,
          userName: userInfo.TelName || userInfo.LoginName
        }
        let response = await initUserCompanyApi(params);
        if (response.success) {
          if (response.code === "0000") {
            this.setCookie("CompanyInfo", {
              companyId: response.result.CurrentCompanyGuid,
              companyName: response.result.Name || response.result.ChineseFullName,
              loginDate: response.loginDate,
              dateFormat:response.dateFormat,
              rNickName:response.rNickName,
              Currency:response.result.Currency,
              enterDate: this.moment(response.result.EnterDate).format('YYYY/MM/DD HH:mm:ss')+'(UTC+8)'
            });
            this.$router.push({path: '/home'});
          } else {
            this.$toast.fail("公司初始化数据失败");
          }
        }
      },
      toSearch() {
        this.$router.push({path: '/search'})
      },
      back() {
        this.$router.push({path: '/'})
      }
    }
  }
</script>

<style lang="less" scoped>
  .wrapper {
    overflow: hidden;
    background: white;

    .header {
      display: flex;
      flex-direction: row;
      align-items: center;
      background: #1fb1c4;
      color: white;
      padding: 3rem 2rem;


      .text {
        font-size: 2rem;
        flex: 1;
      }

      img {
        width: 6rem;
      }
    }

    .search-panel {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-items: center;
      padding: 0 1rem 0 0;

      .van-search {
        flex: 1;
      }

      .add-company {
        color: #00a6bc;
        text-align: center;
        font-size: 1.4rem;
      }
    }

    .company-list {
      overflow-y: auto;
      height: calc(100vh - 30rem);

      .company-item {
        border-bottom: 1px solid #ececec;
        padding: 1.5rem 2rem;

        .full-name {
          display: block;
          font-size: 1.4rem;
        }

        .about-info {
          display: block;
          font-size: 1.2rem;
          margin-top: 1.5rem;
          color: #b3b3b3;
        }

        .role-name {
          color: #00a6bc;
          font-size: 1.4rem;
          font-weight: bold;
        }
      }
    }
  }
</style>
